import { Formatters, Messages } from '../../codegen/Localize';

export function characterCounter(args: {value: string, maximum: number}): string {
  const remaining = args.maximum - args.value.length;
  const overflow = args.value.length > args.maximum;

  if (overflow) {
    return Messages.metricsMetadataPanelDescriptionCharacterLimitExceeded({
      total: Formatters.formatCount(args.value.length),
      maximum: Formatters.formatCount(args.maximum)
    });
  }

  return Messages.metricsMetadataPanelDescriptionCharactersRemaining({
    REMAINING_COUNT: remaining,
    REMAINING_COUNT_LOC: Formatters.formatCount(remaining)
  });
}
